import React from "react";
import { Link } from "../../layouts/menus/link";

type IHeaderButton = {
  title: string;
  url: string;
  icon?: any;
};

interface ICardHeader {
  title: string;
  subtitle?: string;
  button?: IHeaderButton;
}

export const CardHeader: React.FC<ICardHeader> = ({
  title,
  subtitle,
  button,
}) => {
  return (
    <div className="">
      <div className="flex flex-wrap items-center justify-between mb-2">
        <div>
          <span className="block text-500 font-medium dark:text-zinc-200 ">
            {title.toUpperCase()}
          </span>
          {subtitle && <p className="text-xs text-gray-700 dark:text-zinc-400">{subtitle}</p>}
        </div>
        {button && (
          <Link to={button.url}>
            <span className="inline-flex items-center py-1 px-2 text-xs text-indigo-500 dark:text-indigo-300 font-medium bg-indigo-50 dark:bg-indigo-950/50 hover:bg-indigo-100 dark:hover:bg-indigo-900 rounded">
              {button.icon}
              {button.title}
            </span>
          </Link>
        )}
      </div>
    </div>
  );
};
